// Badge «rimborso» in testata della pagina ordine.
//
// Nasce dal caso 2001684276-A (22/07): 465,00 fatturati, 30,00 rimborsati, e in
// Order Manager non se ne vedeva traccia da nessuna parte — né in pagina ordine
// né in fatturazione. Richiesta di Davide: «deve essere segnato nella pagina
// ordine se c'è un rimborso».
import { formatMoney } from "@/shared/format";
import type { Order } from "../../types";

export function RefundBadge({ order }: { order: Order }) {
  if (!order.hasRefund) return null;

  // 🔑 Importo assente NON vuol dire zero: vuol dire «rilevato, da confermare».
  // Sono due messaggi diversi e vanno detti diversamente, altrimenti il badge
  // tace proprio quando c'è qualcosa da fare.
  // Estratto in una const perché TypeScript possa restringere il tipo: il
  // controllo su `order.refundAmount` non si propaga fino a formatMoney.
  const importo = order.refundAmount;
  const importoNoto = importo != null;

  // Fondo pieno + testo bianco, come gli altri badge di questa pagina: la
  // coppia `bg-X-soft` + `text-X` non passa il contrasto WCAG nella palette
  // del progetto (verificato 17/07).
  return (
    <span
      data-testid="refund-badge"
      title={
        importoNoto
          ? "Il cliente è stato rimborsato: in fatturazione c'è la nota di credito"
          : "Rimborso rilevato ma senza importo: va confermato dalla pagina Fatturazione"
      }
      className={`inline-flex shrink-0 items-center gap-1 rounded-full px-2 py-px text-[10px] font-semibold uppercase tracking-[0.04em] text-white ${
        importoNoto ? "bg-amber" : "bg-red"
      }`}
    >
      {importo != null
        ? `Rimborsato ${formatMoney(importo, order.currency)}`
        : "Rimborso da confermare"}
    </span>
  );
}
